import React from 'react'

const SideDocumentsIcon = (
  <>
    <path
      d="M15.0835 19.5837H0.916829C0.695816 19.5837 0.483854 19.4959 0.327574 19.3396C0.171293 19.1833 0.0834961 18.9713 0.0834961 18.7503V1.25033C0.0834961 1.02931 0.171293 0.81735 0.327574 0.66107C0.483854 0.50479 0.695816 0.416992 0.916829 0.416992H10.9168L15.9168 5.41699V18.7503C15.9168 18.9713 15.829 19.1833 15.6728 19.3396C15.5165 19.4959 15.3045 19.5837 15.0835 19.5837Z"
      fill="#E3E3E3"
    />
    <path
      d="M10.917 0.416992V4.58366C10.917 4.80467 11.0048 5.01663 11.1611 5.17291C11.3174 5.32919 11.5293 5.41699 11.7503 5.41699H15.917L10.917 0.416992Z"
      fill="#AEAEAE"
    />
    <path
      d="M12.167 14.584H3.83366C3.72315 14.584 3.61717 14.6279 3.53903 14.706C3.46089 14.7842 3.41699 14.8901 3.41699 15.0007C3.41699 15.1112 3.46089 15.2171 3.53903 15.2953C3.61717 15.3734 3.72315 15.4173 3.83366 15.4173H12.167C12.2775 15.4173 12.3835 15.3734 12.4616 15.2953C12.5398 15.2171 12.5837 15.1112 12.5837 15.0007C12.5837 14.8901 12.5398 14.7842 12.4616 14.706C12.3835 14.6279 12.2775 14.584 12.167 14.584Z"
      fill="#AEAEAE"
    />
    <path
      d="M12.167 10.417H3.83366C3.72315 10.417 3.61717 10.4609 3.53903 10.539C3.46089 10.6172 3.41699 10.7232 3.41699 10.8337C3.41699 10.9442 3.46089 11.0501 3.53903 11.1283C3.61717 11.2064 3.72315 11.2503 3.83366 11.2503H12.167C12.2775 11.2503 12.3835 11.2064 12.4616 11.1283C12.5398 11.0501 12.5837 10.9442 12.5837 10.8337C12.5837 10.7232 12.5398 10.6172 12.4616 10.539C12.3835 10.4609 12.2775 10.417 12.167 10.417Z"
      fill="#AEAEAE"
    />
    <path
      d="M7.16699 6.25H3.83366C3.72315 6.25 3.61717 6.2939 3.53903 6.37204C3.46089 6.45018 3.41699 6.55616 3.41699 6.66667C3.41699 6.77717 3.46089 6.88315 3.53903 6.96129C3.61717 7.03944 3.72315 7.08333 3.83366 7.08333H7.16699C7.2775 7.08333 7.38348 7.03944 7.46162 6.96129C7.53976 6.88315 7.58366 6.77717 7.58366 6.66667C7.58366 6.55616 7.53976 6.45018 7.46162 6.37204C7.38348 6.2939 7.2775 6.25 7.16699 6.25Z"
      fill="#AEAEAE"
    />
  </>
)

export default SideDocumentsIcon
